export const LABELLING = {
  APPROVED_BODY_NUMBER: process.env.REACT_APP_APPROVED_BODY_NUMBER || null,
  PMDA_NUMBER: process.env.REACT_APP_PMDA_NUMBER || null,
  APP_NAME:
    process.env.REACT_APP_APP_NAME ||
    (typeof document !== "undefined" && document.title) ||
    "pDx",
};
